export default __webpack_public_path__ + "static/media/polaroid_cameras.6a5c81db.png";